<template>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      recaptchaIsReady: 'recaptcha/isReady',
    }),

    action() {
      return this.$route.params.action
    },
  },

  methods: {
    ...mapActions({
      getRecaptchaToken: 'recaptcha/getToken',
    }),

    async getToken() {
      const token = await this.getRecaptchaToken(this.action)

      if (token) {
        location.hash = `grt=${token}`
      }
    },
  },

  watch: {
    recaptchaIsReady: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getToken()
        }
      },
    },
  },
}
</script>
